import { createSlice } from '@reduxjs/toolkit'
import {RootState} from './store'
import { ITaskStatus } from '../interface/ITask';


const TaskStatusSlice = createSlice({
  name: 'TaskStatusData',
   initialState: [
    {
      "id": 1,
      "status": "New",
      "color": "yellow"
    },
    {
      "id": 2,
      "status": "In Progress",
      "color": "orange"
    },
    {
      "id": 5,
      "status": "Complete",
      "color": "lightgreen"
    },
    {
      "id": 6,
      "status": "Pending",
      "color": "red"
    },
    {
      "id": 1000,
      "status": "Pending Assembly",
      "color": "cyan"
  },
  {
    "id": 1002,
    "status": "Review",
    "color": "cyan"
}
  ] as ITaskStatus[],
  reducers: {
    
    incrementTask: (state, action) => {    
      state = action.payload;
      //return action.payload
    }
  },
})



// Action creators are generated for each case reducer function
export const {   incrementTask } = TaskStatusSlice.actions
export const TaskStatusData = (state: RootState)=>state
export default TaskStatusSlice.reducer